import { withStyles, WithStyles, createStyles } from "@mui/styles";
import classNames from "classnames";
import * as React from "react";

const style = createStyles({
    quillRegion: {
        flex: 1,
        display: "flex",
        flexFlow: "column nowrap",
        position: "relative",

        "& .ql-container": {
            "border-bottom-left-radius": "0.5em",
            "border-bottom-right-radius": "0.5em",
            background: "#fefcfc",
            overflow: "auto",
            flexGrow: 1
        },

        /* Transparent Theme */
        "& .ql-transparent .ql-container": {
            border: 0,
            background: "#fff",
            padding: 2
        },

        "& .ql-transparent .ql-toolbar": {
            display: "block",
            background: "#fff",
            border: 0
        },
        "& .ql-transparent .ql-editor": {
            background: "#fff",
            border: 0,
            padding: 0
        },

        /* Snow Theme */
        "& .ql-snow.ql-toolbar": {
            background: "#eaecec",
        },

        /* Bubble Theme */
        "& .ql-bubble.ql-editor": {
            border: "1px solid #ccc",
            "border-radius": "0.5em",
        },

        "& .quill": {
            height: "100%",
            maxHeight: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
        }
    },

    editor: {
        minHeight: "10rem",
        "& .quill": {
            position: "absolute",
        },
    },

});

interface IProps {
    id?: string;
    viewOnly?: boolean;
    showToolbar?: boolean;
}

type Props = IProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & WithStyles<typeof style>;


const QuillContainer: React.FC<Props> = (props) => {
    const { id, className, classes, children, viewOnly, style, showToolbar } = props;

    const myClasses = classNames({
        ["quill-region"]: true,                 // Apenas adiciona um nome de classe para uso dentro dos BLOT's.
        ["ql-hide-toolbar"]: !showToolbar,
        [classes.quillRegion]: true,
        [classes.editor]: !viewOnly,
        [className]: className != null
    });

    if (viewOnly)
        return (
            <div id={id} className={myClasses} style={style}>
                <div className="quill">
                    <div className="ql-snow">
                        <div className="ql-editor">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        );

    return <div className={myClasses} style={style}>{children}</div>;
};

QuillContainer.defaultProps = {
    viewOnly: false,
    showToolbar: true,
};

export default withStyles(style)(QuillContainer);
